// Phase I0.3 — DNAStat primitive.
// Larger numeric block for DNA panels: label + Bebas Neue 32px value +
// optional sub. Lives in a hairlined raised tile.

import type { CSSProperties, ReactNode } from "react";

export interface DNAStatProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  /** Tint the value in saffron when true. */
  accent?: boolean;
  style?: CSSProperties;
}

export function DNAStat({ label, value, sub, accent, style }: DNAStatProps) {
  return (
    <div
      style={{
        padding: 12,
        background: "var(--sa-bg-raised)",
        border: "1px solid var(--sa-hairline)",
        borderRadius: 4,
        ...style,
      }}
    >
      <div
        style={{
          fontFamily: "var(--sa-font-mono)",
          fontSize: 9.5,
          color: "var(--sa-fg-muted)",
          letterSpacing: "0.18em",
          textTransform: "uppercase",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: "var(--sa-font-stat)",
          fontSize: 32,
          lineHeight: 1,
          color: accent ? "var(--sa-accent-saffron)" : "var(--sa-fg-primary)",
          marginTop: 6,
        }}
      >
        {value}
      </div>
      {sub !== undefined && sub !== null ? (
        <div
          style={{
            fontFamily: "var(--sa-font-mono)",
            fontSize: 10,
            color: "var(--sa-fg-muted)",
            marginTop: 4,
          }}
        >
          {sub}
        </div>
      ) : null}
    </div>
  );
}
